import React, { useContext, useEffect, useRef, useState } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import MobileContext from '../../context/mobile';
import styles from './WrapVacancies.module.scss';
import Footer from '../../components/Footer';
import MoreStory from '../../components/MoreStory';
import StatesContext from '../../context/states';
import PathContext from '../../context/path';
import ArticlePopup from '../../components/ArticlePopup';

const WrapVacancies = () => {
  const path = useContext(PathContext);
  const isMobile = useContext(MobileContext);
  const [articleOpened, setArticleOpened] = useState(false);
  const [isSearchFetching, setSearchFetching] = useState(false);
  const [dataArticles, setDataArticles] = useState(null);
  const [dataArticle, setDataArticle] = useState(null);
  const [hrefArticle, setHrefArticle] = useState(null);
  const [hrefVacancy, setHrefVacancy] = useState(null);
  const [hrefInternship, setHrefInternship] = useState(null);
  const [queriesFilter, setQueriesFilter] = useState(null);
  const [queriesSearch, setQueriesSearch] = useState(null);
  const [filterCollapses, setFilterCollapses] = useState({});
  const [dataFilter, setDataFilter] = useState(null);
  const [endpoint, setEndpoint] = useState(null);

  const [baseVacancy, setBaseVacancy] = useState(null);
  const [dataVacancy, setDataVacancy] = useState(null);
  const [baseInternship, setBaseInternship] = useState(null);
  const [dataInternship, setDataInternship] = useState(null);
  const [vacancyLength, setVacancyLength] = useState(0);

  const refPopup = useRef(null);
  const refPopupClose = useRef(null);

  const openArticle = (href) => setHrefArticle(href);
  const updateHrefVacancy = (id) => setHrefVacancy(id);
  const updateHrefInternship = (id) => setHrefInternship(id);
  const updateFilterCollapses = (val) => setFilterCollapses(val);
  const updateQueriesFilter = (val) => setQueriesFilter(val);
  const updateQueriesSearch = (val) => setQueriesSearch(val);
  const updateSearchFetching = () => setQueriesSearch(queriesSearch);
  const updateVacancyLength = (num) => setVacancyLength(num);

  const useCurrentPath = () => {
    const id = useMatch('/:id');
    return id?.params?.id ?? 'main';
  };

  const currentPath = useCurrentPath().toLowerCase();

  useEffect(() => {
    if (currentPath !== 'vacanvies') setArticleOpened(false);
    return () => setArticleOpened(false);
  }, [currentPath]);

  useEffect(() => {
    if (!endpoint || !hrefArticle) return;

    const query = `
      {
        article(article_id: ${hrefArticle}) {
          title
          image { url }
          author {
            name
            description
            image { url }
          }
          content {
            attributes {
              ... on ArticleContentText { text }
              ... on ArticleContentImage { image { url } }
              ... on ArticleContentVideo { video { url } }
            }
          }
        }
      }
    `;

    fetch(`${endpoint}/graphql`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.data.article) {
          setDataArticle(data.data.article);
          setArticleOpened(true);
        }
      })
      .catch(console.error);
  }, [endpoint, hrefArticle]);

  // загрузка endpoint
  useEffect(() => {
    fetch(`${path}/data/config.json`)
      .then((res) => res.json())
      .then((data) => {
        if (data.endpoint) setEndpoint(data.endpoint);
      });
  }, [path]);

  useEffect(() => {
    if (!endpoint) return;

    const query = `
      {
        cities { id name key }
        scopes {
          id name position description
          block_number_1 block_number_2 block_number_3
          block_text_1 block_text_2 block_text_3
        }
        professionalRoles { id name }
        employments { id name }
        experiences { id name }
        articles {
          id title short_description
          image { url }
        }
        vacancies {
          id name active
          scope { id name }
          city { id name }
          experience { id name }
          employment { id name }
          role { id name }
        }
        internships {
          id name active
          scope { id name }
          city { id name }
          experience { id name }
          employment { id name }
          role { id name }
        }
      }
    `;

    fetch(`${endpoint}/graphql`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ query }),
    })
      .then((res) => res.json())
      .then((data) => {
        const tempData = { ...data.data };
        delete tempData.vacancies;
        delete tempData.internships;
        delete tempData.articles;

        setDataFilter(tempData);
        setDataVacancy(data.data.vacancies);
        setBaseVacancy(data.data.vacancies);
        setDataArticles(data.data.articles);
        setDataInternship(data.data.internships);
        setBaseInternship(data.data.internships);
      })
      .catch(console.error);
  }, [endpoint]);

  useEffect(() => {
    const popup = refPopup.current;
    const body = document.body;
    const root = document.querySelector('#root');

    if (articleOpened) {
      popup.classList.add(styles.active);
      body.style.overflow = 'hidden';
      root.style.overflow = 'hidden';
      body.style.pointerEvents = 'none';
      root.style.pointerEvents = 'none';
    } else {
      popup.classList.remove(styles.active);
      body.style.overflow = '';
      root.style.overflow = '';
      body.style.pointerEvents = '';
      root.style.pointerEvents = '';
      setTimeout(() => {
        setHrefArticle(null);
        setDataArticle(null);
      }, 180);
    }

    return () => {
      popup.classList.remove(styles.active);
      body.style.overflow = '';
      root.style.overflow = '';
      body.style.pointerEvents = '';
      root.style.pointerEvents = '';
    };
  }, [articleOpened]);

  useEffect(() => {
    if (!endpoint) return;

    if (queriesSearch) {
      const query = `
        {
          vacanciesSearch(query: "${queriesSearch}") {
            id name active
            scope { id name }
            city { id name }
            experience { id name }
            employment { id name }
            role { id name }
          }
          internshipsSearch(query: "${queriesSearch}") {
            id name active
            scope { id name }
            city { id name }
            experience { id name }
            employment { id name }
            role { id name }
          }
        }
      `;

      fetch(`${endpoint}/graphql`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.data.vacanciesSearch) {
            setDataVacancy(data.data.vacanciesSearch);
          }
          if (data.data.internshipsSearch) {
            setDataInternship(data.data.internshipsSearch);
          }
        })
        .catch(console.error);
    } else if (queriesSearch === '') {
      setDataVacancy(baseVacancy);
      setDataInternship(baseInternship);
      setDataFilter(dataFilter);
    }
  }, [endpoint, queriesSearch, dataFilter, baseVacancy, baseInternship]);

  useEffect(() => {
    const trigger = document.querySelector('[data-vacancy-trigger]');
    const close = refPopupClose.current;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const path = close.querySelector('path');
        if (entry.isIntersecting) {
          path.style.fill = `#008359`;
          path.style.stroke = `#008359`;
        } else {
          path.style.fill = '';
          path.style.stroke = '';
        }
      });
    });

    if (dataArticle && isMobile) {
      if (articleOpened) observer.observe(trigger);
      else observer.unobserve(trigger);
    } else if (dataArticle && !isMobile) {
      observer.unobserve(trigger);
    }

    return () => {
      const path = close.querySelector('path');
      path.style.fill = '';
      path.style.stroke = '';
      if (trigger) observer.unobserve(trigger);
    };
  }, [dataArticle, articleOpened, isMobile]);

  useEffect(() => {
    if (isSearchFetching) setSearchFetching(false);
  }, [isSearchFetching]);

  return (
    <>
      <StatesContext.Provider
        value={{
          openArticle,
          articleOpened,
          updateQueriesFilter,
          updateQueriesSearch,
          dataFilter,
          vacancyLength,
          dataVacancy,
          dataInternship,
          queriesFilter,
          hrefVacancy,
          updateHrefVacancy,
          hrefInternship,
          updateHrefInternship,
          updateSearchFetching,
          updateVacancyLength,
          endpoint,
          dataArticles,
          updateFilterCollapses,
          filterCollapses,
          baseVacancy,
          baseInternship,
        }}
      >
        <div className={styles.popup} ref={refPopup}>
          <div
            className={styles.popup__close}
            ref={refPopupClose}
            onClick={() => setArticleOpened(false)}
          >
            <svg
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.8337 17.5299L32.6572 30.3535L30.3495 32.6611L17.526 19.8376L16.9957 19.3072L16.4653 19.8376L3.64177 32.6611L1.3341 30.3535L14.1577 17.5299L14.688 16.9996L14.1577 16.4692L1.3341 3.64568L3.64177 1.338L16.4653 14.1616L16.9957 14.6919L17.526 14.1616L30.3495 1.338L32.6572 3.64568L19.8337 16.4692L19.3033 16.9996L19.8337 17.5299Z"
                fill="white"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
          </div>

          <div className={styles.popup__body}>
            {dataArticle && <ArticlePopup data={dataArticle} />}
          </div>
        </div>

        <div className="WrapVacancies">
          <Outlet />
          <div className={styles.final} data-header-trigger={true}>
            <div className="container">
              <div className={styles.more}>
                <MoreStory color={'green_invite'} type={'vacancy'} />
              </div>
              <div className={styles.footer}>
                <Footer color={'vac'} />
              </div>
            </div>
          </div>
        </div>
      </StatesContext.Provider>
    </>
  );
};

export default WrapVacancies;
